const IS_UNDEFINED = obj => typeof obj === "undefined";
const IS_EMPTY_STRING = obj => obj === "";
const IS_NULL = obj => obj === null;
const IS_VALID = obj => !IS_UNDEFINED(obj) && !IS_NULL(obj) && !IS_EMPTY_STRING(obj)

function GENERATE_RANDOM (length = 0, type = "") {
  let text = "",
      stringPosible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
      numberPosible = "0123456789",
      stringNumberPosible = `${stringPosible}${numberPosible}`,
      possible = stringNumberPosible;

  if (type === "string") {
    possible = stringPosible;
  } else if (type === "number") {
    possible = numberPosible;
  }

  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

module.exports = {
  IS_UNDEFINED,
  IS_EMPTY_STRING,
  IS_NULL,
  IS_VALID,
  IS_LENGTH_ZERO: obj => obj.length === 0,
  IS_PARAMETER_INCOMPLETE: jsonObject => { // require specific parameter ex. IS_PARAMETER_INCOMPLETE({ firstName, lastName })
    for (let key in jsonObject) {
      if (IS_UNDEFINED(jsonObject[key]) || IS_EMPTY_STRING(jsonObject[key])) {
        return `${key} is required.`;
      }
    }

    return false;
  },
  IS_WRONG_PARAMETER_TYPE: objectArray => { // validate the type of parameters ex. IS_WRONG_PARAMETER_TYPE([ { firstName, type: 'string' }, { lastName, type: 'string'} ])
    for (let item of objectArray) {
      let keys = Object.keys(item),
        indexOfType = keys.indexOf("type"),
        indexOfParameter = indexOfType === 1 ? 0 : 1;

      if (item.type.toLowerCase() !== typeof item[keys[indexOfParameter]]) {
        return `${keys[indexOfParameter]} should be ${item.type}`;
      }
    }

    return false;
  },
  RETRIEVE_ALL: (query, options = {}) => {
    return new Promise((resolve, reject) => {
      var result = [];
      var chunk_size = 1000;
      var processCallback = function(res) {
        result = result.concat(res);
        if (res.length === chunk_size) {
          process(result.length);
        } else {
          resolve(result);
        }
      };
      var process = function(skip) {
        if (skip) {
          query.skip(skip);
        }
        query.limit(chunk_size);
        query.find(options).then(
          function(res) {
            processCallback(res);
          },
          function(error) {
            console.log(error);
            reject(error);
          }
        );
      };
      process(false);
    });
  },
  GENERATE_RANDOM,
  IS_EMAIL_VALID: (email) => {

    let regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return regExp.test(String(email).toLowerCase());

  }
};



// WEBPACK FOOTER //
// ./utils/index.js